import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//Components
import Property from './Property';
import Layout from '../common/Layout';
import Wrapper from '../common/Wrapper';
import SearchForm from '../common/Search/SearchForm';
import TableHeader from '../common/Table/TableHeader';
import Loading from '../common/Loading';
import { useSyles } from '../common/Wrapper/styles';
//Material
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getAllProperties } from '../../redux/properties/thunks';
import { fieldsFilter, headCells } from './constants';
import useScan from '../../hooks/useScan';
import { getSorting, stableSort } from 'src/helpers/sorts';

const Properties = (props: any) => {
  const classes = useSyles();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate(); // habilitar navigate para redirección
  const [filter, setFilter] = useState('');
  const { setDestination } = useScan();
  const [firstLoad, setFirstLoad] = useState(true);
  // obtener el state
  const { properties, loading } = useSelector((state: any) => state.properties);
  const { selectedWarehouse } = useSelector((state: any) => state.warehouses);
  const [pagination, setPagination] = useState({
    rowsPerPage: 10,
    page: 1,
    total: 1,
    order: 'desc',
    orderBy: 'name',
  });
  useEffect(() => {
    setDestination('act-l-pro', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateDataByPagination = async () => {
    await dispatch(getAllProperties({ filter, pagination }));
  };

  useEffect(() => {
    pagination.page = 1;
    updateDataByPagination();
    setFirstLoad(false);
    // eslint-disable-next-line
  }, [filter, selectedWarehouse]);

  useEffect(() => {
    setPagination({
      ...pagination,
      total: properties.paginate?.items ? properties.paginate.items : 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [properties.paginate]);

  useEffect(() => {
    if (!firstLoad) {
      updateDataByPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.rowsPerPage, pagination.page]);

  // función que redirige de forma programada
  const redirectAdd = () => {
    navigate(`/properties/new`, { replace: true });
  };
  //Tabla
  const emptyRows =
    pagination.rowsPerPage -
    Math.min(
      pagination.rowsPerPage,
      pagination.total - pagination.page * pagination.rowsPerPage
    );
  const { order, orderBy } = props;

  const handleChangePage = (event: any, page: any) => {
    setPagination({
      ...pagination,
      page: ++page,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPagination({
      ...pagination,
      rowsPerPage: event.target.value,
    });
  };

  //Fin de tabla
  //Filtros
  const initialValuesFilter = {
    key: 'barcode',
    name_value: '',
  };

  // cuando el usuario haga submit en el formulario de busqueda
  const submitFilterProperties = (values: any) => {
    //preparar la data para filtrar
    if (values.key !== '' && values.name_value !== '') {
      setFilter(`&${values.key}=${values.name_value}`);
    } else {
      setFilter('');
    }
  };
  const sliceX = 0;
  const sliceY = pagination.rowsPerPage;
  //Fin de los filtros
  return (
    <Layout>
      <Wrapper
        button
        buttonTitle='Agregar propiedad'
        actionTitle={() => redirectAdd()}
      >
        <Grid className={classes.containerHeader} container item spacing={4}>
          <Grid item xs={12} sm={8} md={8} className={classes.button}>
            <SearchForm
              submitFilter={submitFilterProperties}
              fields={fieldsFilter}
              initialValues={initialValuesFilter}
              filter={'PRO'}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} className={classes.button}>
            <Button
              size='medium'
              color='secondary'
              variant='contained'
              onClick={() => redirectAdd()}
            >
              Agregar propiedad
              <Add />
            </Button>
          </Grid>
        </Grid>
        {!loading ? (
          <div>
            <div>
              <TableContainer component={Paper}>
                <Table aria-label='simple table'>
                  <TableHeader cellsList={headCells} />
                  <TableBody>
                    {stableSort(
                      properties.properties,
                      getSorting(order, orderBy)
                    )
                      .slice(sliceX, sliceY)
                      .map((property: any) => (
                        <Property key={property.nid} property={property} />
                      ))}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 49 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              component='div'
              count={pagination.total}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page - 1}
              labelRowsPerPage='Renglones por página'
              backIconButtonProps={{
                'aria-label': 'Anterior',
              }}
              nextIconButtonProps={{
                'aria-label': 'Siguiente',
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        ) : (
          <Loading />
        )}
      </Wrapper>
    </Layout>
  );
};

export default Properties;
